import { render, staticRenderFns } from "./ConfigurazioneContabilitaSoggettiEditComponent.vue?vue&type=template&id=681d6a33"
import script from "./ConfigurazioneContabilitaSoggettiEditComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneContabilitaSoggettiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports